import { rem } from "polished";
import React from "react";
import styled from "styled-components";
import Button, { ButtonWrapper } from "../../../Button";
import Modal from "../../../Modal";
import ItemDetails from "./ItemDetails";

const ItemDetailModal = ({
  title= '',
  selectedItem,
  openDetailModal,
  onSetDetailModal,
}) => {
  return (
    <Modal
      wrapperId="detailModal"
      isOpen={openDetailModal}
      overlayClick
      handleClose={() => onSetDetailModal(false)}
      styles={{
        maxWidth: "600px",
        maxHeight: "50%",
        height: "100%",
        width: "100%",
      }}
      parentStyles={{
        zIndex: 9999,
      }}
      title={title || selectedItem.label || ""}
    >
      {selectedItem && (
        <ItemDetails
          item={selectedItem}
          onModalClose={() => onSetDetailModal(false)}
        />
      )}
    </Modal>
  );
};
export default ItemDetailModal;
